import { HostingService } from '@application/hosting.service';
import { HttpResponse, HttpService } from '@application/http.service';
import { Injectable } from '@visiba/instantiation';

@Injectable()
export class OfficeApiService {
	private readonly baseUri: string;

	constructor(
		private readonly httpService: HttpService,
		private readonly hostingService: HostingService,
	) {
		this.baseUri = `${this.hostingService.location ?? ''}/api/office`;
	}

	public getIdentity(licenceHolderId: number): HttpResponse<InferedOfficeModel> {
		return this.httpService.get(`${this.baseUri}/prioritized/${licenceHolderId}/identity/info`);
	}

	public survey(licenceHolderId: number, alias: string, langcode: string): HttpResponse<SurveyQuestionInfo[]> {
		return this.httpService.get(`${this.baseUri}/${licenceHolderId}/surveys/${alias}/questions/${langcode}`);
	}

	public setCompleted(licenceHolderId: number, bookingId: number): HttpResponse<null> {
		return this.httpService.put(`${this.baseUri}/${licenceHolderId}/bookings/${bookingId}/completed`, null);
	}

	public surveyAnswers(
		licenceHolderId: number,
		alias: string,
		data: {
			BookingCallTicket: string;
			Answers: AnswerSurveyQuestionInput[];
		},
	): HttpResponse<unknown> {
		return this.httpService.post(`${this.baseUri}/${licenceHolderId}/surveys/${alias}`, data);
	}
}

// Reason, the {} type is needed to get the typing to work as intended.
// eslint-disable-next-line @typescript-eslint/ban-types
type InferedOfficeModel = {};

export enum SurveyAnswerValueType {
	Int4SatisfactionScore = 'Int4SatisfactionScore',
	Text500 = 'Text500',
}

export interface SurveyQuestionInfo {
	AnswerType: SurveyAnswerValueType;
	QuestionAlias: string;
	QuestionText: string | null;
	SortValue: number;
	SurveyQuestionId: number;
}

export interface AnswerSurveyQuestionInput {
	IntValue: number | null;
	QuestionAlias: string;
	StringValue: string | null;
}
